module.exports = {
	extends: [
		'/',
		'base',
		'popover',
		'popover'
	],

	config: {
		orientation: 'NE-NW',
		distance: {
			x: '.5em'
		},
		triggerOffset: {
			y: 1
		}
	},
};
